import React from 'react'
import styled from 'styled-components'

import { ISwitcher } from './index'

const SSwitcher = styled.div`
  height: 40px;
  display: flex;
  & > * > label {
    border-radius: 0;
  }

  & > *:first-child > label {
    border-top-left-radius: ${(props => props.theme.general.borderRadius)};
    border-bottom-left-radius: ${(props => props.theme.general.borderRadius)};
  }

  & > *:last-child > label {
    border-top-right-radius: ${(props => props.theme.general.borderRadius)};
    border-bottom-right-radius: ${(props => props.theme.general.borderRadius)};
  }

  & > *:not(:first-child) > label  {
    border-left: 1px solid rgba(126, 88, 35, .23);
  }
`

const SItem = styled.label`
  display: block;
  height: 100%;
  background-color: white;
  color: ${(props) => props.theme.colors.activeButtonText};
  font-size: ${(props) => props.theme.typography.buttonFontSize};
  line-height: 20px;
  transition: 0.3s;
  padding: 10px 25px;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.colors.accent};
  }
`

const SRadio = styled.input`
  display: none;
  &:checked + label {
    background-color: ${(props) => props.theme.colors.accent};
  }
`

const Switcher: React.FC<ISwitcher> = (props) => {
  const { values, activeValue, name, id, className, ...rest } = props
  return (
    <SSwitcher className={className} id={id}>
      {values.map((item, i) => {
        const {value, displayName} = item
        const id = `switch-${name}-${i}`
        return (
          <div key={value}>
            <SRadio {...rest} id={id} name={name} value={value} type="radio" checked={value.toString() === activeValue.toString()} />
            <SItem htmlFor={id}>{displayName}</SItem>
          </div>
        ) 
      })}
    </SSwitcher>
  )
}

export default Switcher